import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Collapse from 'shared/ui/collapse';
import { GenerativeLabelsType } from 'entities/Files/types';
import { useFileEditorStore } from 'store/file-editor';
import GenerativeLabelsModal from '../generative-labels-modal';
import Label from '../label';

const GenerativeResearch: FC = () => {
	const { t } = useTranslation();
	const { fileDetails, setFileDetails } = useFileEditorStore();
	const [isOpenModal, setIsOpenModal] = useState(false);
	const [labelsDetails, setLabelsDetails] = useState<GenerativeLabelsType & { labelIndex: number }>();

	const closeModal = () => {
		setIsOpenModal(false);
		setLabelsDetails(undefined);
	};
	return (
		<>
			<GenerativeLabelsModal
				open={isOpenModal}
				handleClose={closeModal}
				labelsDetails={labelsDetails}
			/>
			<Collapse
				title={t('files.labels.research')}
				addHandler={() => setIsOpenModal(true)}
				count={fileDetails?.labels.length}
			>
				{fileDetails?.labels.map((item, i) => (
					<Label
						key={`${item.name}-${i}`}
						title={item.name}
						description={item.prompt}
						editHandler={() => {
							setLabelsDetails({ ...item, labelIndex: i });
							setIsOpenModal(true);
						}}
						deleteHandler={() => {
							setFileDetails({
								...fileDetails,
								labels: fileDetails.labels.filter((_, labelIndex) => labelIndex !== i),
							});
						}}
					/>
				))}
			</Collapse>
			<Collapse title={t('files.labels.results')} count={fileDetails?.recognizedLabels.length}>
				{fileDetails?.recognizedLabels.map((item, i) => (
					<Label key={i} title={item.label || ''} description={item.content} />
				))}
			</Collapse>
		</>
	);
};

export default GenerativeResearch;
